import { useEntrypointContext } from "../infrastructure/entrypoint/EntrypointContext";
import { getEnvBaseUrl } from "../infrastructure/translation/translatedUrls";

export function KeepAliveIdP() {
  const entrypoint = useEntrypointContext();

  if (!entrypoint.rolle) {
    return <></>;
  }

  const keepAliveUrl =
    "https://login." + getEnvBaseUrl().replace("https://", "") + "/keep-alive";

  return (
    <iframe
      aria-hidden={true}
      key={"hidden_keep_alive"}
      src={keepAliveUrl}
      title={"hidden_keep_alive"}
      id={"hidden_keep_alive"}
      style={{ border: 0, width: 0, height: 0 }}
    />
  );
}
